import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';

import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ThemeService } from './core/services/theme.service';
import { JobCostingApi } from './core/services/job-costing/job-costing.api';
import { JobCostingHttpApi } from './core/services/job-costing/job-costing-http.api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Before first paint, so the shell does not draw light and then flip.
    provideAppInitializer(() => inject(ThemeService).init()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        loaderInterceptor,
        errorInterceptor,
        authInterceptor
      ])
    ),
    provideAnimations(),
    { provide: JobCostingApi, useClass: JobCostingHttpApi },
  ]
};
